module.exports = __webpack_public_path__ + "static/desktop-membership-a271c07c9e6365dbebcd611baae6898b.png";